module.exports = __webpack_public_path__ + "static/media/icon.984f07c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/OptionsBoard/icon.png
// module id = 974
// module chunks = 0